import { classNameTriskeleParser } from '../../../utilities/customStyles';
import {
  Body2500C, Body3400N, Body4400N, CAPTION_TEXT_MIDDLENAVY_2, RESTORE_ICON
} from '../../../utilities/generatedClasses';
import Icon from '../../../components/Icon';

const RecommendationCard = (props) => {
  const {
    data, dataIndex, index, windowWidth, showRecommendation, openUserProfile
  } = props;
  const qtyDescrptrArray = data.QtyDescrptr_Qty_UnitIdArray;
  let qtyDescrptrText = `${qtyDescrptrArray[0].Qty} ${qtyDescrptrArray[0].Unit}`;
  let qtyDescrptrText2 = '';
  if(qtyDescrptrArray[0] && qtyDescrptrArray[0].QtyDescrptr == "Hours"){
    if(qtyDescrptrArray[0].Qty != 0 && qtyDescrptrArray[1].Qty == 0){
      qtyDescrptrText = `${qtyDescrptrArray[0].Qty}${qtyDescrptrArray[0].Unit}`
    } else if(qtyDescrptrArray[0].Qty == 0 && qtyDescrptrArray[1].Qty != 0){
      qtyDescrptrText = `${qtyDescrptrArray[1].Qty}${qtyDescrptrArray[1].Unit}`
    } else {
      qtyDescrptrText = `${qtyDescrptrArray[0].Qty}${qtyDescrptrArray[0].Unit} ${qtyDescrptrArray[1].Qty}${qtyDescrptrArray[1].Unit}`;
    }
  }
else if (
  qtyDescrptrArray?.[0] &&
  qtyDescrptrArray[0].QtyDescrptr === "MinutesQty"
) {
  const totalMinutes = Number(qtyDescrptrArray[0].Qty || 0);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) {
    qtyDescrptrText = `${hours}hr${minutes}min`;
  } else if (hours > 0) {
    qtyDescrptrText = `${hours}hr`;
  } else {
    qtyDescrptrText = `${minutes}min`; // includes 0min if totalMinutes is 0
  }
}
  else if (qtyDescrptrArray[0] && qtyDescrptrArray[0].LowQty) {
    qtyDescrptrText = `${qtyDescrptrArray[0].LowQty}-${qtyDescrptrArray[0].HighQty} ${qtyDescrptrArray[0].Unit}`;
  } else if (qtyDescrptrArray.length === 4) {
    const firstProp = qtyDescrptrArray[0].QtyDescrptr.substring(0, 3).toLowerCase();
    const secondProp = qtyDescrptrArray[2].QtyDescrptr.substring(0, 3).toLowerCase();

    qtyDescrptrText = `${firstProp} ${qtyDescrptrArray[0].Qty}-${qtyDescrptrArray[1].Qty} ${qtyDescrptrArray[0].Unit}`;
    qtyDescrptrText2 = ` ${secondProp} ${qtyDescrptrArray[2].Qty}-${qtyDescrptrArray[3].Qty} ${qtyDescrptrArray[2].Unit}`;
  } else if (qtyDescrptrArray.length === 2) {
    qtyDescrptrText = `${qtyDescrptrArray[0].Qty}-${qtyDescrptrArray[1].Qty} ${qtyDescrptrArray[0].Unit}`;
  }
  return (
    <div
      className={`card ${classNameTriskeleParser(data.VisualNameOne, data.VisualTypeOne, 'Card')}`}
      style={{
        opacity: data && data.isHidden ? 0 : 1
      }}
      onClick={() => showRecommendation(dataIndex, index)}
      aria-hidden="true">
      <div
        className="card_content"
        style={{
          marginLeft: windowWidth <= 878 ? '4px' : 'unset'
        }}>
        <div className="row-flex align-center space-between full_width">
          {data.selectedMeasure
            && (
            <div
              className={`MeasureIcon MeasureRec size_40 ${windowWidth <= 1078 ? 'icon-margin-2px' : 'icon-margin-10px'} 
             ${classNameTriskeleParser(data.selectedMeasure.VisualNameOne, data.selectedMeasure.VisualTypeOne, 'Icon')} `}
              style={{ WebkitMaskImage: data.selectedMeasure.MeasureIcon }}
             />
            )
          }
           {!data.selectedMeasure
            && (
            <div
              className={`MeasureIcon size_40 ${windowWidth <= 1078 ? 'icon-margin-2px' : 'icon-margin-10px'}  `}
             
             />
            )
          }
            <label className={`card_title align-right mr-16 ${Body2500C} 
    max-width: 60%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`}
            >{data.PrcsParmtrValueOne}
            </label>

        </div>

        <div className="row-flex align-center space-between full_width">
            <div style={{ marginRight: '8px', width: '100%' }}>
              <label className={`card_body align-right mr-16 ${Body3400N}`}>{qtyDescrptrText}</label>
              {qtyDescrptrText2 !== '' && <label className={`card_body align-right mr-16 ${Body3400N}`}>{qtyDescrptrText2}</label>
              }
            </div>
        </div>


        <div className="card-footer-content row-flex align-center space-between full_width">
            <Icon
              classNames={`small_size 
                      ${data.occurence ? '' : 'no-opacity'}
                      ${windowWidth <= 1078 ? 'icon-margin-2px' : 'icon-margin-10px'} 
                      ${RESTORE_ICON} `}

            />
         
              <label className={`card_footer mr-16 ${Body4400N}`}>
                {data.ActnPhrase}
                <span
                  style={{ display: 'block', textAlign: 'right' }}
                  className={CAPTION_TEXT_MIDDLENAVY_2}
                  aria-hidden="true"
                  onClick={() => openUserProfile(data)}> {data.ProviderName}
                </span>
              </label>
        </div>
      </div>
    </div>
  );
};

export default RecommendationCard;
